[
  {
    "legacy_key": "ChatGpt",
    "product": {
      "product_id": "9cc4bcac-4217-4a08-9d96-fa523abd2690",
      "display_name": "ChatGPT Desktop",
      "ai_provider": "openai",
      "category": "desktop_assistant"
    }
  },
  {
    "legacy_key": "ClaudeCode",
    "product": {
      "product_id": "2934790e-cc9f-4aa9-a8e5-95c31ca8b3e1",
      "display_name": "Claude Code",
      "ai_provider": "anthropic",
      "category": "coding_assistant"
    }
  },
  {
    "legacy_key": "ClaudeDesktop",
    "product": {
      "product_id": "047f2fc9-1eaf-4411-9852-f159b88d5679",
      "display_name": "Claude Desktop",
      "ai_provider": "anthropic",
      "category": "desktop_assistant"
    }
  },
  {
    "legacy_key": "CodexCli",
    "product": {
      "product_id": "47c05b14-3417-46bd-b060-9941af193189",
      "display_name": "Codex CLI",
      "ai_provider": "openai",
      "category": "coding_assistant"
    }
  },
  {
    "legacy_key": "CodexDesktop",
    "product": {
      "product_id": "17c1b8d1-3577-41a0-9d85-d0257ea0a665",
      "display_name": "Codex Desktop",
      "ai_provider": "openai",
      "category": "desktop_assistant"
    }
  },
  {
    "legacy_key": "GeminiCli",
    "product": {
      "product_id": "a5d3cab9-950d-422c-a244-ab2546051144",
      "display_name": "Gemini CLI",
      "ai_provider": "google",
      "category": "coding_assistant"
    }
  },
  {
    "legacy_key": "GrokBuild",
    "product": {
      "product_id": "0f8a5bb1-c777-4411-a546-28f21d4bb141",
      "display_name": "Grok CLI",
      "ai_provider": "xai",
      "category": "coding_assistant"
    }
  },
  {
    "legacy_key": "Cursor",
    "product": {
      "product_id": "7189f73c-2456-4ced-b611-03ec15acf463",
      "display_name": "Cursor",
      "ai_provider": "cursor",
      "category": "editor"
    }
  },
  {
    "legacy_key": "M365Copilot",
    "product": {
      "product_id": "5b8a9513-ff17-444e-b420-76b6a6c167f9",
      "display_name": "Microsoft 365 Copilot",
      "ai_provider": "microsoft",
      "category": "desktop_assistant"
    }
  },
  {
    "legacy_key": "MicrosoftCopilot",
    "product": {
      "product_id": "6877ee8c-5b83-439c-87c0-17072eb64b89",
      "display_name": "Microsoft Copilot",
      "ai_provider": "microsoft",
      "category": "desktop_assistant"
    }
  },
  {
    "legacy_key": "CopilotInOffice",
    "product": {
      "product_id": "e023e796-6098-4581-bc83-ea57914df027",
      "display_name": "Copilot in Office",
      "ai_provider": "microsoft",
      "category": "desktop_assistant"
    }
  },
  {
    "legacy_key": "CopilotCli",
    "product": {
      "product_id": "5d5c1768-3344-497e-ad14-0aa495d55ed6",
      "display_name": "GitHub Copilot CLI",
      "ai_provider": "microsoft",
      "category": "coding_assistant"
    }
  },
  {
    "legacy_key": "GitHubCopilotDesktop",
    "product": {
      "product_id": "b46f51f1-12a2-42f3-bff7-b250208e3738",
      "display_name": "GitHub Copilot",
      "ai_provider": "microsoft",
      "category": "desktop_assistant"
    }
  },
  {
    "legacy_key": "AntigravityIde",
    "product": {
      "product_id": "33327032-7e6e-439b-8d15-6abb868a9097",
      "display_name": "Antigravity IDE",
      "ai_provider": "google",
      "category": "editor"
    }
  },
  {
    "legacy_key": "AntigravityDesktop",
    "product": {
      "product_id": "f4e85441-cc84-4a5c-9558-fba59ef1bfd5",
      "display_name": "Antigravity Desktop",
      "ai_provider": "google",
      "category": "desktop_assistant"
    }
  },
  {
    "legacy_key": "AntigravityCli",
    "product": {
      "product_id": "2fa7339b-d306-4c9a-af05-9a83de83c8fe",
      "display_name": "Antigravity CLI",
      "ai_provider": "google",
      "category": "coding_assistant"
    }
  },
  {
    "legacy_key": "FactoryDroid",
    "product": {
      "product_id": "15d590f5-94d6-471b-97f4-3f704a5b9aee",
      "display_name": "Factory Droid",
      "ai_provider": "factory",
      "category": "coding_assistant"
    }
  },
  {
    "legacy_key": "FactoryDesktop",
    "product": {
      "product_id": "ccc76339-5ad9-4369-845b-a1a410d64392",
      "display_name": "Factory Desktop",
      "ai_provider": "factory",
      "category": "desktop_assistant"
    }
  },
  {
    "legacy_key": "OpenClaw",
    "product": {
      "product_id": "afb2b102-874d-4262-8deb-fcf6ebfccb9f",
      "display_name": "OpenClaw",
      "ai_provider": "openclaw",
      "category": "desktop_assistant"
    }
  },
  {
    "legacy_key": "PerplexityDesktop",
    "product": {
      "product_id": "2b42e247-b719-424a-8a2e-8844cf87d2c5",
      "display_name": "Perplexity",
      "ai_provider": "perplexity",
      "category": "desktop_assistant"
    }
  },
  {
    "legacy_key": "PerplexityComet",
    "product": {
      "product_id": "68d52b51-4ff4-448e-a50a-4aec966b63a3",
      "display_name": "Comet",
      "ai_provider": "perplexity",
      "category": "desktop_assistant"
    }
  },
  {
    "legacy_key": "Ollama",
    "product": {
      "product_id": "fc4d81d0-3377-418d-98b3-3cd61aaf3ac4",
      "display_name": "Ollama",
      "ai_provider": "local",
      "category": "local_runtime"
    }
  },
  {
    "legacy_key": "LMStudio",
    "product": {
      "product_id": "9428db92-7f6f-443f-b6db-f24f9481752b",
      "display_name": "LM Studio",
      "ai_provider": "local",
      "category": "local_runtime"
    }
  },
  {
    "legacy_key": "LlamaCpp",
    "product": {
      "product_id": "b519abf9-2310-42cc-9927-2086a53f4365",
      "display_name": "llama.cpp",
      "ai_provider": "local",
      "category": "local_runtime"
    }
  },
  {
    "legacy_key": "KoboldCpp",
    "product": {
      "product_id": "2cf6d856-37fc-4327-ac51-7930be65082b",
      "display_name": "KoboldCpp",
      "ai_provider": "local",
      "category": "local_runtime"
    }
  },
  {
    "legacy_key": "Jan",
    "product": {
      "product_id": "8e4b3d9a-5f76-4620-a5f0-296f79139bb7",
      "display_name": "Jan",
      "ai_provider": "local",
      "category": "local_runtime"
    }
  },
  {
    "legacy_key": "GPT4All",
    "product": {
      "product_id": "74a54640-16f4-4dca-916b-bc21eeb4d1d4",
      "display_name": "GPT4All",
      "ai_provider": "local",
      "category": "local_runtime"
    }
  },
  {
    "legacy_key": "Llamafile",
    "product": {
      "product_id": "0c055e4d-a34a-4247-8575-6c51734e4375",
      "display_name": "Llamafile",
      "ai_provider": "local",
      "category": "local_runtime"
    }
  },
  {
    "legacy_key": "Faraday",
    "product": {
      "product_id": "d620b5ce-6327-4c01-9c55-2ba265237863",
      "display_name": "Faraday",
      "ai_provider": "local",
      "category": "local_runtime"
    }
  },
  {
    "legacy_key": "LocalAI",
    "product": {
      "product_id": "6a47633e-7522-4167-bae0-c7caab9016c6",
      "display_name": "LocalAI",
      "ai_provider": "local",
      "category": "local_runtime"
    }
  },
  {
    "legacy_key": "Tabby",
    "product": {
      "product_id": "4572053b-f3ee-4155-ad5a-2982843b49bf",
      "display_name": "Tabby",
      "ai_provider": "local",
      "category": "local_runtime"
    }
  },
  {
    "legacy_key": "TextGenerationWebUI",
    "product": {
      "product_id": "884fca29-c72e-47e5-9d99-77240ee76f41",
      "display_name": "text-generation-webui",
      "ai_provider": "local",
      "category": "local_runtime"
    }
  },
  {
    "legacy_key": "Vllm",
    "product": {
      "product_id": "14062e15-b6ec-46dd-a0f3-1575c8e3c5d6",
      "display_name": "vLLM",
      "ai_provider": "local",
      "category": "local_runtime"
    }
  },
  {
    "legacy_key": "SGLang",
    "product": {
      "product_id": "2d437425-ba0d-4b73-a0c7-62005a92cdd3",
      "display_name": "SGLang",
      "ai_provider": "local",
      "category": "local_runtime"
    }
  },
  {
    "legacy_key": "Cortex",
    "product": {
      "product_id": "66008828-649c-4a75-9f5e-674f64e34792",
      "display_name": "Cortex.cpp",
      "ai_provider": "local",
      "category": "local_runtime"
    }
  },
  {
    "legacy_key": "FastFlowLM",
    "product": {
      "product_id": "07db9d43-5bad-4876-b4e8-9b0979810723",
      "display_name": "FastFlowLM",
      "ai_provider": "local",
      "category": "local_runtime"
    }
  },
  {
    "legacy_key": "MlxLm",
    "product": {
      "product_id": "4909393a-6a14-4572-966e-5ae2744f030d",
      "display_name": "MLX LM",
      "ai_provider": "local",
      "category": "local_runtime"
    }
  },
  {
    "legacy_key": "FoundryLocal",
    "product": {
      "product_id": "c8bcc762-d591-4a97-a959-76e750d5a9a0",
      "display_name": "Foundry Local",
      "ai_provider": "local",
      "category": "local_runtime"
    }
  },
  {
    "legacy_key": "HuggingFaceTgi",
    "product": {
      "product_id": "db58c6d8-848e-4b79-8383-85223c61422b",
      "display_name": "Hugging Face TGI",
      "ai_provider": "local",
      "category": "local_runtime"
    }
  },
  {
    "legacy_key": "ExLlamaV3",
    "product": {
      "product_id": "6b8a431f-f533-46b1-822f-e1ddc5b69b8f",
      "display_name": "ExLlamaV3",
      "ai_provider": "local",
      "category": "local_runtime"
    }
  },
  {
    "legacy_key": "Laya",
    "product": {
      "product_id": "acf316af-1caf-4202-9cb6-edb91cbfa2ac",
      "display_name": "Laya",
      "ai_provider": "local",
      "category": "local_runtime"
    }
  }
]
